/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getEstimateLatestActions = ({ params } = {}) => axios.get(`estimate_latest_actions`, { params });